import React from "react";
import { useAuth } from "../context/AuthContext";
import { Shield } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import CoursesManager from "./admin/CoursesManager";
import ContentManager from "./admin/ContentManager";
import GrantsManager from "./admin/GrantsManager";

export default function AdminPanel() {
  const { user } = useAuth();
  return (
    <main className="pt-[72px] min-h-screen relative overflow-hidden">
      <div className="absolute -top-10 right-0 h-72 w-72 rounded-full bg-[#ff3798]/15 blob" />
      <div className="max-w-7xl mx-auto px-5 py-10 relative z-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-12 w-12 rounded-2xl bg-[#ff3798]/15 border border-[#ff3798]/30 flex items-center justify-center text-[#ff3798]"><Shield size={24} /></div>
          <div><h1 className="text-3xl font-extrabold">Админ-панель</h1><p className="text-white/50 text-sm">Управляйте всем контентом сайта, {user?.name}</p></div>
        </div>
        <Tabs defaultValue="courses">
          <TabsList className="bg-white/[0.04] border border-white/10 p-1 rounded-2xl flex-wrap h-auto">
            <TabsTrigger value="courses" className="data-[state=active]:bg-[#ff3798] data-[state=active]:text-white rounded-xl px-5">Курсы и уроки</TabsTrigger>
            <TabsTrigger value="content" className="data-[state=active]:bg-[#ff3798] data-[state=active]:text-white rounded-xl px-5">Тексты главной</TabsTrigger>
            <TabsTrigger value="grants" className="data-[state=active]:bg-[#ff3798] data-[state=active]:text-white rounded-xl px-5">Доступы</TabsTrigger>
          </TabsList>
          <TabsContent value="courses" className="mt-6"><CoursesManager /></TabsContent>
          <TabsContent value="content" className="mt-6"><ContentManager /></TabsContent>
          <TabsContent value="grants" className="mt-6"><GrantsManager /></TabsContent>
        </Tabs>
      </div>
    </main>
  );
}
